import { DateTime } from 'luxon';

export function displayTime(dt: DateTime): string {
  return dt.toFormat('HH:mm');
}

export function displayTimeRange(start: DateTime, end: DateTime): string {
  return `${displayTime(start)} - ${displayTime(end)}`;
}
